<template>
  <v-btn
    icon
    color="white"
    class="header-action-btn"
    v-bind="attrs"
    v-on="listeners"
    @click="onPressed"
  >
    <slot name="icon"></slot>
  </v-btn>
</template>

<script>
export default {
  name: "HeaderActionButton",
  props: {
    onPressed: {
      type: Function,
      required: true,
    },
    attrs: {
      type: Object,
      default: () => ({}),
    },
    listeners: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>


<style scoped>
.header-action-btn {
  background: rgba(255, 255, 255, 0.15) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
}

.header-action-btn:hover {
  background: rgba(255, 255, 255, 0.25) !important;
  border-color: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.header-action-btn::v-deep .v-btn__content {
  opacity: 1;
}
</style>